import React from 'react';
import { Calculator, Trash2, Layers } from 'lucide-react';
import Button from '../../../../../components/ui/Button';

/**
 * Компонент боковой панели для сохраненных расчетов
 */
const SavedCalculationsSidebar = ({ 
  savedCalculations, 
  deleteSavedCalculation, 
  loadSavedCalculation 
}) => {
  // Если нет сохраненных расчетов
  if (!savedCalculations || savedCalculations.length === 0) {
    return (
      <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
        <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
          <Calculator className="w-5 h-5 mr-2 text-cyan-500" />
          Сохраненные расчеты
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Здесь будут отображаться сохраненные варианты расчетов рабочего времени для сравнения и повторного использования.
        </p>
      </div>
    );
  }

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-medium text-gray-900 dark:text-white flex items-center">
          <Calculator className="w-5 h-5 mr-2 text-cyan-500" />
          Сохраненные расчеты
        </h3>
        <span className="text-sm text-gray-500 dark:text-gray-400">
          {savedCalculations.length} {savedCalculations.length === 1 ? 'вариант' : savedCalculations.length < 5 ? 'варианта' : 'вариантов'}
        </span>
      </div>

      <div className="space-y-4">
        {savedCalculations.map((calc) => (
          <div 
            key={calc.id} 
            className="bg-gray-50 dark:bg-gray-700/30 border border-gray-200 dark:border-gray-700 rounded-lg p-4 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors group"
          >
            <div className="flex justify-between items-start mb-2">
              <h4 className="text-sm font-medium text-gray-900 dark:text-white">
                {calc.name}
              </h4>
              <div className="flex items-center space-x-2">
                <Button
                  size="sm"
                  variant="ghost"
                  icon={<Layers className="w-4 h-4" />}
                  onClick={() => loadSavedCalculation(calc.id)}
                  title="Загрузить параметры"
                />
                <Button
                  size="sm"
                  variant="ghost"
                  icon={<Trash2 className="w-4 h-4 text-red-500" />}
                  onClick={() => deleteSavedCalculation(calc.id)}
                  title="Удалить"
                />
              </div>
            </div>
            <div className="text-xs text-gray-600 dark:text-gray-400">
              <div className="flex justify-between mb-1">
                <span>Период:</span>
                <span className="font-medium">
                  {calc.results.periodName}
                </span>
              </div>
              <div className="flex justify-between mb-1">
                <span>Рабочих дней:</span>
                <span>
                  {calc.results.totalWorkingDays}
                </span>
              </div>
              <div className="flex justify-between mb-1">
                <span>Рабочих часов:</span>
                <span>
                  {calc.results.totalWorkingHours}
                </span>
              </div>
              {calc.results.totalWageAmount > 0 && (
                <div className="flex justify-between">
                  <span>Заработная плата:</span>
                  <span className="font-semibold text-green-600 dark:text-green-400">
                    {calc.results.totalWageAmount.toLocaleString('ru-RU')} ₽
                  </span>
                </div>
              )}
            </div>
            <div className="mt-2 text-xs text-gray-500 dark:text-gray-500">
              Сохранено: {new Date(calc.date).toLocaleDateString('ru-RU')}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SavedCalculationsSidebar;